import React, { useEffect, useState } from "react";
import TextArea from "../../../../ui/common/TextArea";
import "./JsonArrayTextArea.scss";

const formatJsonArray = (value) => {
  if (Array.isArray(value)) return JSON.stringify(value, null, 2);
  if (typeof value === "string") return value;
  return "[]";
};

const fixMissingCommas = (raw) => {
  return raw.replace(
    /("(?:[^"\\]|\\.)*")(\s+)("(?:[^"\\]|\\.)*")/g,
    "$1,$2$3",
  );
};

const repairJsonArray = (raw, emptyValue) => {
  let fixed = raw;
  fixed = fixed.replace(/,(\s*[\]\}])/g, "$1");
  fixed = fixMissingCommas(fixed);
  if (fixed.trim() === "") return emptyValue;
  try {
    const parsed = JSON.parse(fixed);
    if (Array.isArray(parsed)) return JSON.stringify(parsed, null, 2);
  } catch {
    /* invalid */
  }
  return null;
};

const JsonArrayTextArea = ({ label, value, onChange, emptyValue = "[]" }) => {
  const [input, setInput] = useState(() => formatJsonArray(value));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const raw = formatJsonArray(value);
    const repaired = repairJsonArray(raw, emptyValue);
    if (repaired !== null) {
      setInput(repaired);
      setError(null);
      if (repaired !== raw) {
        onChange(repaired);
      }
    } else {
      setInput(raw);
      setError("The field contains an incorrect array.");
    }
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value;
    const withCommas = fixMissingCommas(raw);

    if (withCommas.trim() === "") {
      setInput(emptyValue);
      setError(null);
      onChange(emptyValue);
      return;
    }

    try {
      const parsed = JSON.parse(withCommas);
      if (Array.isArray(parsed)) {
        const repaired = JSON.stringify(parsed, null, 2);
        setInput(repaired);
        setError(null);
        onChange(repaired);
        return;
      }
    } catch {
      /* invalid */
    }

    setInput(raw);
    setError("The field contains an incorrect array.");
  };

  const handleBlur = () => {
    const repaired = repairJsonArray(input, emptyValue);
    if (repaired !== null) {
      setInput(repaired);
      setError(null);
      if (repaired !== input) {
        onChange(repaired);
      }
    } else {
      setError("The field contains an incorrect array.");
    }
  };

  return (
    <div className="json-array-textarea">
      <TextArea
        className="textarea-code-editor"
        label={label}
        value={input}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default JsonArrayTextArea;
